import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button";
import styles from "./index.module.scss";

const QRInput = ({
  handleQROtpSubmit,
  verificationAttempted,
  digit = 6,
  numberOfAvailalbeTries,
  handleRescanQR
}) => {
  const { t } = useTranslation();
  const [OTPValue, setOTPValue] = useState(Array(digit).fill(""));

  const handleChange = (index, event) => {
    const rawValue = event.target.value;

    // Only allow single alphanumeric characters
    const sanitized = rawValue.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 1);

    const updatedOtp = [...OTPValue];
    updatedOtp[index] = sanitized;
    setOTPValue(updatedOtp);
  };

  const handleInputNavigation = (event) => {
    const { key } = event;
    const input = event.target;
    const form = input.form;
    const index = input.tabIndex;

    if ((key === "Backspace" || key === "Delete") && input.value === "") {
      const prev = form?.elements[index - 1];
      if (prev) prev.focus();
    } else if (/^[a-zA-Z0-9]$/.test(key) && input.value) {
      const next = form?.elements[index + 1];
      if (next) next.focus();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    const newOtp = [...OTPValue];

    for (let i = 0; i < digit; i++) {
      newOtp[i] = paste[i] || "";
    }
    setOTPValue(newOtp)
  }

  return (
    <div className={styles.otpContainer}>
      <form onSubmit={(e) => {
        e.preventDefault(); handleQROtpSubmit(OTPValue.join(""));
      }}>
        <p className={styles.OTPHeader2fa}>{t("qrInput.header2fa")}</p>
        <p className={styles.OTPHeader}>
          {t("qrInput.subtext")}
          <a href="/guide.pdf" download className={styles.downloadLink}>
            {t("qrInput.checkGuide")}
          </a>
        </p>
        {numberOfAvailalbeTries < 10 && verificationAttempted ? (
          <div className={styles.errorBox}>
            <div className={styles.iconWrapper}>
              <NotificationImportantIcon style={{ color: '#EA1D25', fontSize: 24 }} />
            </div>
            <div className={styles.errorContent}>
              <p
                className={styles.errorText}
                dangerouslySetInnerHTML={{
                  __html: t("qrInput.otpError", { count: numberOfAvailalbeTries })
                }}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={styles.inputWrapper} onPaste={handlePaste}>
          {OTPValue &&
            OTPValue.map((elem, index) => (
              <input
                key={index}
                name={"otp" + elem}
                type="text"
                autoComplete="off"
                className={styles.otpInput}
                value={elem}
                onChange={e => {
                  handleChange(index, e);
                }}
                tabIndex={index}
                maxLength="1"
                onKeyDown={handleInputNavigation}
              />
            ))}
        </div>
        <Button
          type="submit"
          color="primary"
          style={{ backgroundColor: "#f5b019" }}
          variant="contained"
          fullWidth
        >
          {t("qrInput.verify")}
        </Button>
      </form>
    </div>
  );
};

export default QRInput;
